import { render, staticRenderFns } from "./agregar.vue?vue&type=template&id=11950946&scoped=true"
import script from "./agregar.vue?vue&type=script&lang=js"
export * from "./agregar.vue?vue&type=script&lang=js"
import style0 from "./agregar.vue?vue&type=style&index=0&id=11950946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11950946",
  null
  
)

export default component.exports